import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { OrdersCoServices } from '../services';
import { Globals } from '../../../globals';
import { SelectedPersonsPage } from '../../components/selected-persons/selected-persons';
import { TPVServices } from '../../tpv/services';
import { PopupErrorsPage } from '../../components/popups/popup-errors/popup-errors';
import { TpvTicketSelectedCashPage } from '../../tpv/tpv-ticket/tpv-ticket-selected/tpv-ticket-selected-cash/tpv-ticket-selected-cash';
import { TranslateService } from '@ngx-translate/core';
import { PopupNewAppsPage } from '../../components/popups/popup-new-apps/popup-new-apps';

/**
 * Generated class for the TpvTicketPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-orders-table',
  templateUrl: 'orders-table.html',
})
export class OrdersTablePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public ordersCoServices: OrdersCoServices,
    public globals: Globals,
    public modalCtrl: ModalController,
    public tpvServices: TPVServices,
    public translate: TranslateService) {



  }

  ionViewWillEnter() {
    this.load(); //Prerare orders for print

    if (this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].state == 'open') {
      this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.waiter = this.globals.waiter;
      this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].ticket.waiter_uid = this.globals.waiter_uid;
      //open comensals
      let profileModal = this.modalCtrl.create(SelectedPersonsPage, {
        origin: 'orders',
        update: false
      });
      profileModal.onDidDismiss(data => {
        this.checkRoomHasCash();
      });
      profileModal.present();
    }
  }


  async load() {
    //get all orders for print
    await this.ordersCoServices.getOrdersAllPrint(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
    await this.ordersCoServices.getOrdersLastPrint(this.globals.restaurant_uid, this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].UID);
  }

  checkRoomHasCash() {
    //Comprovamos que la mesa tenga una caja existente asignada
    var _table_nocash = this.ordersCoServices.cashs_array.find(e => e.UID === this.ordersCoServices.tables_array[this.ordersCoServices.selected_table_tpv_index].cash_uid);
    if (!_table_nocash) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, {
        title: this.translate.instant('general-cajas'),
        origin: 'tpv-error-caja',
        msg: this.translate.instant('tpv-ticket-esta-mesa-tiene-caja-no-existe')
      });
      profileModal.onDidDismiss(data => {
        if (data) {
          if (data.open_change_cash) {
            this.navCtrl.push(TpvTicketSelectedCashPage);
          }
          if (data.close) {
            //this.navCtrl.push(TpvLoaderPage);
            this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
          }
        }

      });
      profileModal.present();
    } else if (!_table_nocash._active) {
      let profileModal = this.modalCtrl.create(PopupErrorsPage, {
        title: this.translate.instant('general-cajas'),
        origin: 'tpv-error-caja',
        msg: 'Caja bloqueda por versión'
      },
        { enableBackdropDismiss: false }
      );
      profileModal.onDidDismiss(data => {
        if (data) {
          if (data.open_change_cash) {
            this.navCtrl.push(TpvTicketSelectedCashPage);
          }
          if (data.close) {
            //this.navCtrl.push(TpvLoaderPage);
            this.navCtrl.push(PopupNewAppsPage, { app: 'pos' });
          }
        }

      });
      profileModal.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/orders/orders-table/orders-table.ts